import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { ContentDetailsPod, type ContentDetailsPodType } from '../ContentDetailsPod/ContentDetailsPod';

type ContentDetailsGroupProps = ComponentProps<'div'> & {
  pods: ContentDetailsPodType[];
  columns?: 2 | 3 | 4;
};

function RenderPods({ pods, columns, className }: { pods: ContentDetailsPodType[]; columns: number; className?: string }) {
  return (
    <div style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }} className={twMerge('grid gap-1', className)}>
      {pods.map(pod => (
        <ContentDetailsPod key={pod.label} {...pod} />
      ))}
    </div>
  );
}

function ContentDetailsGroup({ className, pods, columns = 2, ...props }: ContentDetailsGroupProps) {
  const remainingPodsCount = pods.length % columns;
  const completeRowPods = pods.slice(0, pods.length - remainingPodsCount);
  const lastRowPods = remainingPodsCount ? pods.slice(-remainingPodsCount) : [];
  return (
    <div className={className} {...props}>
      <RenderPods pods={completeRowPods} columns={columns} />
      {lastRowPods.length > 0 ? <RenderPods pods={lastRowPods} columns={remainingPodsCount} className="mt-1" /> : null}
    </div>
  );
}

export { ContentDetailsGroup, type ContentDetailsGroupProps };
